var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericTest',{attrs:{"test":_vm.test,"semester":_vm.semester,"test_id":_vm.test_id,"answer":_vm.answer,"previous_answer":_vm.previous_answer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }